import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    constructor(
        private snackBar: MatSnackBar
    ) { }

    showSuccess(msg: string) {
        this.snackBar.open(msg, '', {
            duration: 3000, // Optional: duration in milliseconds
            panelClass: ['success-snackbar'] // Optional: custom CSS class for styling
        });
    }
    showError(msg: string) {
        this.snackBar.open(msg, '', {
            duration: 3000, // Optional: duration in milliseconds
            panelClass: ['error-snackbar'] // Optional: custom CSS class for styling
        });
    }
}